import PropTypes from "prop-types";
import React from "react";

const MeterListItem = ({ meter }) => {
  return (
    <div className="flex flex-row">
      <div className="flex flex-col items-start w-full">
        <div className="font-bold w-full truncate">
          {meter.customer.customerName}
        </div>
        <div className="w-full truncate">{meter.meterId}</div>
        <div className="w-full truncate">
          {meter.customer.state || meter.customer.province},{" "}
          {meter.customer.country}
        </div>
        <div className="w-full truncate">Status</div>
      </div>
    </div>
  );
};

MeterListItem.propTypes = {
  meter: PropTypes.object.isRequired
};

export default MeterListItem;
